import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-estadisticas',
  templateUrl: 'skeleton-estadisticas.html'
})
export class SkeletonEstadisticasComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-estadisticas/skeleton-estadisticas.ts